// environment.token.ts
import { InjectionToken } from '@angular/core';
import { Environment } from '../../model/environment.interface';

export const ENVIRONMENT = new InjectionToken<Environment>('Environment configuration');
